
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'MiniTitleComponent',
  props: {
    title: String
  }
})
